import { StoreData } from 'app/types-shared';
import * as resolvers from 'app/infrastructure/ui/renderer/resolvers';
import { getChildEntities } from 'app/infrastructure/store/query';
import { CaseState } from 'app/area/case/types-store';
import { ConnectedComponentProps } from 'app/infrastructure/ui/types-uischema';
import { ComplexValue } from 'app/infrastructure/ui/form/types';

export const childEntityFieldValueAsOptions = (
  tableName: string,
  fieldName: string
) => (state: CaseState, uiEngineProps: ConnectedComponentProps) => {
  const caseData: StoreData = resolvers.getCaseData(state, uiEngineProps);
  const entityContext = resolvers.getEntityContext(state, uiEngineProps);

  const entities = getChildEntities(caseData, entityContext.path, tableName);

  const fieldValues =
    entities &&
    entities
      .filter(e => e[fieldName] && (e[fieldName] as any).length)
      .map(e => {
        return e[fieldName] && (e[fieldName][0] as ComplexValue<number>);
      })
      .reduce((prev, c) => {
        prev.findIndex(v => v.value === c.value) === -1 && prev.push(c);
        return prev;
      }, []);

  return {
    options: fieldValues
  };
};
